module.exports = __webpack_public_path__ + "static/media/home_14.63e8e6a8.jpg";